"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var deepGet = function deepGet(object, path, defaultValue) {
  var res = (!Array.isArray(path) ? path.replace(/\[/g, '.').replace(/]/g, '').split('.') : path).reduce(function (o, k) {
    return (o || {})[k];
  }, object);
  return ![undefined, null].includes(res) ? res : defaultValue;
};

var arrayGroupBy = function arrayGroupBy(arr, key) {
  var newArr = [];
  var types = {};
  var i;
  var j;
  var cur;

  for (i = 0, j = arr.length; i < j; i++) {
    cur = arr[i];

    if (!(cur[key] in types)) {
      var _types$cur$key;

      types[cur[key]] = (_types$cur$key = {}, (0, _defineProperty2["default"])(_types$cur$key, key, cur[key]), (0, _defineProperty2["default"])(_types$cur$key, "data", []), _types$cur$key);
      newArr.push(types[cur[key]]);
    }

    types[cur[key]].data.push(cur);
  }

  return newArr;
};

var getRandomArrayElements = function getRandomArrayElements(arr, count) {
  var shuffled = arr.slice(0);
  var i = arr.length;
  var min = i - count;
  var temp;
  var index;

  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }

  return shuffled.slice(min);
};

function _basePath(path) {
  if (Array.isArray(path)) return path;
  return path.replace(/\[/g, '.').replace(/\]/g, '').split('.');
}

function set(object, path, value) {
  if ((0, _typeof2["default"])(object) !== 'object') return object;

  _basePath(path).reduce(function (o, k, i, _) {
    if (i === _.length - 1) {
      o[k] = value;
      return null;
    } else if (k in o) {
      return o[k];
    } else {
      o[k] = /^\d{1,}$/.test(_[i + 1]) ? [] : {};
      return o[k];
    }
  }, object);

  return object;
}

var _default = {
  set: set,
  deepGet: deepGet,
  arrayGroupBy: arrayGroupBy,
  getRandomArrayElements: getRandomArrayElements
};
exports["default"] = _default;